const ShyTitle = (title: string): React.JSX.Element => {
    const shyIndex = title.indexOf('forsikring');
    if (shyIndex) {
        title = `${title.substring(0, shyIndex)}\u00ad${title.substring(shyIndex)}`;
    }
    return <span style={{ wordBreak: 'break-word', hyphens: 'auto' }}>{title}</span>;
};

export default ShyTitle;
